import React from "react";
import "./styles.scss";
const OurClient = () => {
  return (
    <>
      <div class="bgGradient blue full">
        <div className="clip-path">
          <h1>GREAT DIGITAL EXPERIENCES</h1>
        </div>
      </div>
      <div className="our-client-heading">
        <div className="heading-col">
          <h1> Our clients </h1>
          <p>
            We pride ourselves on building successful, end to end web and mobile
            applications.
          </p>
        </div>
      </div>
    </>
  );
};

export default OurClient;
